import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e66b8a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container inner" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "container-sm" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "/articles",
    class: "backBtn"
}, "Back", -1));
const _hoisted_5 = { class: "article_content__header" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "d-block text-primary" };
const _hoisted_8 = {
    key: 2,
    class: "article_content__header--author"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["innerHTML"];
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'article_content',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const sanitisedLeadIn = computed(() => {
            if (!props.d.introduction)
                return '';
            // Use a regular expression to remove the <h3> tags
            const contentWithoutH3 = props.d.introduction.replace(/<\/?h3>/g, '');
            return contentWithoutH3;
        });
        return (_ctx, _cache) => {
            const _component_badge = _resolveComponent("badge");
            const _component_arrow = _resolveComponent("arrow");
            return (_openBlock(), _createElementBlock("div", {
                class: "article_content",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                (__props.d.category)
                                    ? (_openBlock(), _createBlock(_component_badge, {
                                        key: 0,
                                        content: [__props.d.category.title === 'Blogs' ? 'News' : __props.d.category.title],
                                        hasGlimmer: "true"
                                    }, null, 8, ["content"]))
                                    : _createCommentVNode("", true),
                                (__props.d.title)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.d.title), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (__props.d.author)
                                    ? (_openBlock(), _createElementBlock("address", _hoisted_8, "By " + _toDisplayString(__props.d.author.title), 1))
                                    : _createCommentVNode("", true),
                                (__props.d.introduction)
                                    ? (_openBlock(), _createElementBlock("h3", {
                                        key: 3,
                                        class: "article_content__header--introduction",
                                        innerHTML: sanitisedLeadIn.value
                                    }, null, 8, _hoisted_9))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_arrow, { animate: "true" })
                            ]),
                            (__props.d.body)
                                ? (_openBlock(), _createElementBlock("article", {
                                    key: 0,
                                    innerHTML: __props.d.body
                                }, null, 8, _hoisted_10))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 4));
        };
    }
});
